import { Button, Card, Checkbox, Col, Form, Input, Row, Select, Spin, Tag } from "antd";
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";

class Create extends React.Component {
  state = {
    value: "",
    permission: []
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    // this.props.getApplicationModules();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.data &&
      this.props &&
      this.props.data &&
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      this.setState({ permission: nextProps.data.access });
    }
  }

  componentWillUnmount() {
    this.props.refreshData();
  }

  handleSubmit = e => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      // console.log('values =>', values);
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  handleSearch = value => {
    const { data } = this.props;
    this.props.fetchRoleData(value, "Role", "role");
  };

  handleChange = value => {
    const { roles } = this.props;
    const copyRole = roles.find(item => item._id === value);
    this.setState({ permission: copyRole.access, value });
  };

  handleOrganisationChange = (org) => {
    // console.log(org);
    if (org) {
      // this.props.getOrgRoles(org);
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      data,
      loading,
      title,
      resource,
      modules,
      roles,
      filters,
      authUser,
      // applicationModules
    } = this.props;
    // console.log(data)
    const { permission } = this.state;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    };

    let orgModules = authUser && authUser.organisation && authUser.organisation.assetProModules || [];
    let allModules = [...modules];
    allModules = (allModules || []).sort(function (a, b) {
      if (a.module && b.module) {
        if (a.module.toUpperCase() < b.module.toUpperCase()) {
          return 1;
        }
        if (a.module.toUpperCase() > b.module.toUpperCase()) {
          return -1;
        }
      }
      return 0;
    });
    const isSuperAdmin = authUser && authUser.superAdmin || false;
    if (isSuperAdmin) {
      orgModules = data && data.organisation && data.organisation.assetProModules || [];
    }
    // console.log(orgModules)
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${resource}`}>
          <Form
            {...formItemLayout}
            onSubmit={this.handleSubmit}
            layout="vertical"
          >
            <Form.Item label="Name">
              {getFieldDecorator("role", {
                rules: [{ required: true, message: "Name is required!" }],
                initialValue: data && data.role
              })(<Input />)}
            </Form.Item>

            {(authUser && authUser.superAdmin) && (
              <Form.Item key={'organisation'} label='Organisation'>
                {getFieldDecorator('organisation', {
                  rules: [{ required: true, message: `Organisation is required!` }],
                  initialValue: data && data['organisation'] && data['organisation']._id,
                })(<Select
                  disabled={title !== 'CREATE'}
                  showSearch
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Please select"
                  onChange={this.handleOrganisationChange}
                >
                  {filters && filters['organisation'] && filters['organisation'].data.data.map(item =>
                    <Select.Option
                      key={item._id}
                      value={item._id}>{item.name}</Select.Option>)}
                </Select>)
                }
              </Form.Item>)
            }

            {(authUser && !authUser.superAdmin) && (
              <Form.Item>
                <div>
                  <label>Select to Copy Permissions</label>
                  <Select
                    disabled={title !== 'CREATE'}
                    showSearch
                    placeholder={"Search Role"}
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onSearch={this.handleSearch}
                    onChange={this.handleChange}
                    notFoundContent={null}
                    style={{ width: "50%", display: "block" }}
                  >
                    {roles &&
                      roles.map(item => {
                        return (
                          <Select.Option key={item._id} value={item._id}>
                            {item.role}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </div>
              </Form.Item>)
            }

            {Object.keys(filters).map(item => {
              if (filters[item].type === "Boolean") {
                if (authUser && !authUser.superAdmin) {
                  return getFormFieldByType(
                    filters,
                    item,
                    getFieldDecorator,
                    data
                  );
                }
              }
            })}

            {allModules.map(module => {
              if (module.name !== 'Organisation' && module.name !== 'AssetDataImport') {
                return (
                  <Form.Item
                    label={<>
                      {sanitizeFieldName(module.modifiedName)}
                      <Tag style={{ marginLeft: '5px' }} color="blue">{module.module}</Tag></>}
                    key={module.name}
                    style={{ flexDirection: "row", marginLeft: "3px" }}
                  >
                    {getFieldDecorator(module.name, {
                      initialValue:
                        permission &&
                          permission.filter(
                            access => access.name === module.name
                          )[0]
                          ? permission.filter(
                            access => access.name === module.name
                          )[0].permissions
                          : []
                    })(
                      // {!isSuperAdmin && !orgModules.includes(module.module)}
                      <Checkbox.Group style={{ width: "100%" }}
                        disabled={!orgModules.includes(module.module)}>
                        <Row>
                          <Col span={8}>
                            <Checkbox value="c">Create</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="r">Read</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="u">Update</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="d">Delete</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="page-setting">Page Setting</Checkbox>
                          </Col>
                          {module.name === "Asset" ||
                            module.name === "Document" ||
                            module.name === "Complaint" ||
                            module.name === "Fuel" ||
                            module.name === "Leasing" ||
                            module.name === "AssetStockTaking" ||
                            module.name === "PreVerification" ||
                            module.name === "SparePart" ||
                            module.name === "ManpowerPerformance" ||
                            module.name === "SaleOrder" ? (
                            <Col span={8}>
                              <Checkbox value="report">Report</Checkbox>
                            </Col>
                          ) : (
                            ""
                          )}
                          {
                            module.name === "PreVerification" ?
                              <Col span={8}>
                                <Checkbox value="reopen">ReOpen PV</Checkbox>
                              </Col> : <> </>
                          }
                          {
                            // Spares Audit: bulk audit and reopening an audit are rights of their own
                            // (the backend SparesAuditGuard checks 'bulk' / 'reopen'). Without these
                            // boxes they could not be granted here, and saving would drop them.
                            module.name === "SparesAudit" ?
                              <>
                                <Col span={8}>
                                  <Checkbox value="bulk">Bulk audit</Checkbox>
                                </Col>
                                <Col span={8}>
                                  <Checkbox value="reopen">Reopen audit</Checkbox>
                                </Col>
                              </> : <> </>
                          }
                        </Row>
                      </Checkbox.Group>
                    )}
                  </Form.Item>
                );
              }
            })}

            <Form.Item>
              <Button
                type="primary"
                className="gx-mb-0"
                htmlType="submit"
                loading={loading}
              >
                {this.props.title === "EDIT" ? "UPDATE" : "CREATE"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: "global_state",
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  }
})(Create);

export default CreateForm;
